import React from 'react'
import ReactMarkdown from 'react-markdown'
import { getFontStyles } from '@ycos/primitives'
import { string } from 'prop-types'
import { createComponent } from '@ycos/fela'

const ALLOWED_ELEMENTS = ['p', 'a']

const LoyaltyContent = createComponent(
  'LoyaltyContent',
  ({ theme }) => ({
    ...getFontStyles(theme.typography, { type: 'Label', name: '4' }),
    color: theme.typography.colors.PrimaryBlack,
    fontWeight: '400',
    lineHeight: '15px'
  }),
  'div'
)

const Link = createComponent(
  'Link',
  ({ theme }) => ({
    ...getFontStyles(theme.typography, { type: 'Label', name: '4' }),
    color: theme.typography.colors.PrimaryBlack,
    fontWeight: '400',
    textDecoration: 'underline',
    lineHeight: '15px'
  }),
  'a'
)

const LoyaltyMarkdown = ({teaserText }) => {
  const renderParagraph = ({ children }) => <LoyaltyContent>{children}</LoyaltyContent>

  const renderLink = ({ children, href }) => (
    <Link href={href}>
      {children}
    </Link>
  )
  /* eslint-disable */
  // because eslint have rule (Disallow passing of children as props)
  return (
    <ReactMarkdown
      components={{
        p: renderParagraph,
        a: renderLink,
      }}
      allowedElements={ALLOWED_ELEMENTS}
      children={teaserText}
    />
  )
  /* eslint-enable */
}

LoyaltyMarkdown.propTypes = {
  teaserText: string.isRequired,
}

export default LoyaltyMarkdown
